module.exports = __webpack_public_path__ + "img/item20.7322a908.png";